export default {
  bottom: '0 4px 2px -1px rgba(0, 0, 0, 0.2)',
  innerStrong: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.2)',
};
